
export const oneriKonusu = [
    { name: "ArGe & Proses" },
    { name: "Bakım ve Enerji" },
    { name: "Bilgi Teknolojileri" },
    { name: "Dış Ticaret" },
    { name: "Dijital Dönüşüm" },
    { name: "Dijital Tasarım" },
    { name: "Finans" },
    { name: "Hammadde Hazırlama" },
    { name: "İdari İşler" },
    { name: "İnsan Kaynakları" },
    { name: "İnsan Kaynakları ve İdari İşler" },
    { name: "Kalite Güvence" },
    { name: "Kilit Müşteri" },
    { name: "Lojistik" },
    { name: "Mali İşler" },
    { name: "Metot/Opex" },
    { name: "Muhasebe" },
    { name: "Planlama" },
    { name: "Satın Alma" },
    { name: "Tedarik Zinciri" },
    { name: "Ticari Pazarlama" },
    { name: "Üretim" },
    { name: "Yurtiçi Satış" },
    { name: "Diğer" }
]

export const department = [
    { name: "ArGe & Proses" },
    { name: "Bakım ve Enerji" },
    { name: "Bilgi Teknolojileri" },
    { name: "Dış Ticaret" },
    { name: "Dijital Dönüşüm" },
    { name: "Dijital Tasarım" },
    { name: "Finans" },
    { name: "Hammadde Hazırlama" },
    { name: "İdari İşler" },
    { name: "İnsan Kaynakları" },
    { name: "İnsan Kaynakları ve İdari İşler" },
    { name: "Kalite Güvence" },
    { name: "Kilit Müşteri" },
    { name: "Lojistik" },
    { name: "Mali İşler" },
    { name: "Metot/Opex" },
    { name: "Muhasebe" },
    { name: "Planlama" },
    { name: "Satın Alma" },
    { name: "Tedarik Zinciri" },
    { name: "Ticari Pazarlama" },
    { name: "Üretim" },
    { name: "Yurtiçi Satış" },
    { name: "Diğer" }
]


export const katkiKonusu = [
    { name: "Ürün Geliştirme" },
    { name: "Kalite İyileştirme" },
    { name: "Proses Geliştirme" },
    { name: "Çalışma Ortamında Gelişim" },
    { name: "Parasal Tasarruf Getirisi" },
    { name: "Moral/Motivasyon Artışı" },
    { name: "Çevre/Güvenlik/Sağlık" },

]

export const actionTypes = [
    "Değerlendirmeye Alındı",
    "Değerlendirme Aşamasında",
    "Değerlendirmeye Alınamadı"
]

export const location = [
    "Çayırova",
    "Pazaryeri",
    "Pendik",
    "Diğer",
]

export const sikayetKonusu = [
    "Çalışma Koşulları",
    "Yönetim ve Liderlik",
    "Ücret ve Yan Haklar",
    "İş ve Yaşam Dengesi",
    "Ayrımcılık ve Eşitsizlik",
    "Mobbing ve İşyerinde Zorbalık",
    "İş Güvenliği ve Sağlık",
    "Yemekhane ve Personel Servis Hizmeti",
    "Diğer"
]

export const oneriler = [
    "Enerji Tasarrufu ve Verimlilik",
    "İş Sağlığı ve Güvenliği İyileştirmeleri",
    "Kalite İyileştirme Önerileri",
    "Üretim Süreçlerinin İyileştirilmesi",
    "Maliyet Azaltma Önerileri",
    "Çevre ve Sürdürülebilirlik",
    "İş Kolaylaştırma / Ergonomi",
    "Bakım ve Ekipman İyileştirmeleri",
    "Dijitalleşme ve Otomasyon Önerileri",
    "Çalışma Ortamı ve Sosyal İmkânlar",
    "Genel İyileştirme Önerileri"
]


export const etiklik = [
    {
        title: "1. Yolsuzluk ve Suistimal",
        items: [
            "Rüşvet / Komisyon Talebi",
            "Dolandırıcılık / Sahtecilik",
            "Kaynakların Kötüye Kullanımı (malzeme, ekipman, şirket varlıkları)",
            "Usulsüz Satın Alma / İhale Yolsuzluğu"
        ],
        subTitle: "Şirket kaynaklarının veya süreçlerinin kişisel çıkar için yasa dışı ya da etik dışı şekilde kötüye kullanılması."
    },
    {
        title: "2. Çıkar Çatışması",
        items: [
            "Şirket Kaynaklarının Kendi Menfaati İçin Kullanılması",
            "Rakip / Tedarikçi ile Gizli İşbirliği",
            "Akraba Kayırmacılığı"
        ],
        subTitle: "Çalışanın kendi menfaati ile şirketin menfaatinin çakıştığı, tarafsızlığın bozulduğu durumlar."

    },
    {
        title: "3. İş Etiği ve Davranış",
        items: [
            "İş Yerinde Taciz (Psikolojik, Fiziksel, Cinsel)",
            "Mobbing / Zorbalık",
            "Ayrımcılık (cinsiyet, yaş, din, dil, ırk vb.)",
            "Uygunsuz Dil / Davranış",
            "Standartlara Uygunsuz Üretim",
            "Kalite Problemlerinin Gizlenmesi",
            "Bilinçli Ürün Hilesi",
        ],
        subTitle: "Çalışanların birbirine ve şirkete karşı sergilediği saygılı, adil ve uygun davranış kuralları."

    },
    // {
    //     title: "4. İş Sağlığı ve Güvenliği (İSG)",
    //     items: [
    //         "İSG Kurallarının İhlali",
    //         "Tehlikeli Davranış veya Ortam",
    //         "Kazaların Gizlenmesi / Bildirilmemesi"
    //     ]
    // },
    {
        title: "4. Finansal Usulsüzlükler",
        items: [
            "Muhasebe Kayıtlarında Manipülasyon",
            "Hatalı veya Kasıtlı Yanlış Raporlama",
            "Fatura / Ödeme Yolsuzlukları"
        ],
        subTitle: "Muhasebe ve finans süreçlerinde manipülasyon, yanlış raporlama veya hileli işlemler yapılması."

    },
    // {
    //     title: "6. Kalite ve Üretim İhlalleri",
    //     items: [
    //         "Standartlara Uygunsuz Üretim",
    //         "Kalite Problemlerinin Gizlenmesi",
    //         "Bilinçli Ürün Hilesi"
    //     ]
    // },
    {
        title: "5. Bilgi Güvenliği ve Gizlilik",
        items: [
            "Yetkisiz Veri Paylaşımı",
            "Bilgi Sızıntısı / Veri Hırsızlığı",
            "Şirket Sırlarının İhlali"
        ],
        subTitle: "Şirket verilerinin, sırlarının ve kişisel bilgilerin yetkisiz erişim, paylaşım veya sızıntılardan korunması."

    },
    {
        title: "6. Çevre ve Sürdürülebilirlik",
        items: [
            "Çevre Kirliliği Yaratma",
            "Atık Yönetimi İhlalleri",
            "Doğaya Zarar Veren Faaliyetler"
        ],
        subTitle: "Şirket faaliyetlerinin çevreye zarar vermemesi ve sürdürülebilirlik ilkelerine uyum göstermesi."

    },
    // {
    //     title: "9. İnsan Hakları ve Çalışma Koşulları",
    //     items: [
    //         "Çalışma Süreleri ve Ücretlerde Usulsüzlük",
    //         "Temel Çalışan Haklarının İhlali"
    //     ]
    // },
    {
        title: "7. Diğer / Belirtilmeyen",
        items: [
            "Yukarıdaki kategorilere uymayan her türlü etik ihlal"
        ],
        subTitle: "Yukarıdaki kategorilere girmeyen fakat etik ihlal kapsamında değerlendirilebilecek her türlü konu."

    }
];